import React from 'react';
import { MdOutlineNoteAlt } from 'react-icons/md';

/**
 * NoteIcon
 * Ikona poznámky pre zvýraznenie sekcií súhrnu alebo dôležitých informácií.
 */
const NoteIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <MdOutlineNoteAlt className={className} {...props} />
);

export default NoteIcon;

